import { Component, Input, OnInit } from "@angular/core";
import { HttpService } from "../../../services/http/http-client.service";
import { ILoteDetalhes } from "../../dto/ILoteDetalhes";
import { downloadErrorReport } from "../../utils/download-error-report";
import { EImportacaoType } from "../table/EImportacaoType";

@Component({
  selector: "ngx-lembrete-importacao",
  templateUrl: "./lembrete.component.html",
  styleUrls: ["./lembrete.component.scss"],
})
export class LembreteImportacaoComponent implements OnInit {
  @Input() loteDetalhes: ILoteDetalhes;
  @Input() url: string;
  @Input() importacaoType: EImportacaoType;

  public EImportacaoType = EImportacaoType;
  public customLogin = null;

  constructor(public http: HttpService) {}

  ngOnInit(): void {
    let resCustom = localStorage.getItem("bway-customLogin");
    this.customLogin = JSON.parse(resCustom);
  }

  downloadErrorReport() {
    downloadErrorReport(this.http, this.loteDetalhes.id, this.importacaoType);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }
}
